import React from 'react'
import LunarSiteTakeoverBackground from 'components/Common/SiteTakeover/LunarSiteTakeoverBackground'
import LunarSiteTakeoverOfferUSPs from 'components/Common/SiteTakeover/LunarSiteTakeoverOfferUSPs'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import moment from 'moment'

const LunarNewYearTakeover: App.SiteTakeover = {
  id: 'lunarnewyear',
  startDate: moment('2025-01-22T00:00:00+1100'),
  endDate: moment('2025-02-06T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['SG', 'HK', 'CN', 'KR', 'MO', 'MY', 'TW', 'VN']),
  imageId: 'gidua9dchhephstwu3jp',
  primaryColour: '#F84916',
  palette: 'default',
  offerTypes: new Set(['hotel']),
  verticals: new Set(['home', 'hotel']),
  backgroundElement: LunarSiteTakeoverBackground,
  heroCarousel: {
    title: 'Happy Lunar New Year',
    subtitle: 'Enjoy exclusive offers! Valid Jan 22 - 6 Feb only',
    verticals: ['home'],
  },
  offerPage: {
    bannerContent: <b>Enjoy Lunar New Year exclusive offers! Only valid Jan 22 - 6 Feb</b>,
    usps: <LunarSiteTakeoverOfferUSPs />,
  },
  landingPage: {
    banner: {
      description: <b>Enjoy Lunar New Year exclusive offers! Only valid Jan 22 - 6 Feb</b>,
    },
  },
  searchPage: {
    bannerContent: <VerticalSpacer gap={2}>
      <Heading variant="heading2">Happy Lunar New Year</Heading>
      <BodyText variant="large">Enjoy exclusive offers! Only valid Jan 22 - 6 Feb</BodyText>
    </VerticalSpacer>,
  },
}

export default LunarNewYearTakeover
